<x-bottom-sheet-layout
  [heading]="data.sheetTitle"
  *ngIf="validateAddressOperation$ | async as operation"
  [class]="'active-step-' + activeStep"
  [xOperation]="operation"
>
  <button xHeaderAction mat-icon-button (click)="confirmCloseBottomSheet()">
    <fa-icon icon="times" xIconSize="small"></fa-icon>
  </button>

  <mat-stepper linear #stepper (selectionChange)="stepChange($event)">
    <mat-step [stepControl]="addressFormGroup" [editable]="true" state="address" label="Address">
      <x-form-panel class="address-form pt-3">
        <form
          id="address-form"
          [formGroup]="addressFormGroup"
          xFormErrorBoundary
          autocomplete="off"
        >
          <x-form-row class="mb-4" heading="Recipient Detail">
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>First Name</mat-label>
                <input
                  matInput
                  placeholder="First Name..."
                  formControlName="firstName"
                  #firstname
                  (focusout)="inputChangedEvent(firstname)"
                />
                <mat-error xFormError="firstName"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  placeholder="Last Name..."
                  formControlName="lastName"
                  #lastname
                  (focusout)="inputChangedEvent(lastname)"
                />
                <mat-error xFormError="lastName"></mat-error>
              </mat-form-field>
            </div>
            <mat-form-field class="col-lg-12">
              <mat-label>Contact Number</mat-label>
              <input
                matInput
                placeholder="Contact number..."
                formControlName="phoneNumber"
                maxlength="16"
                xOnlyPositiveNumber
                type="tel"
                #contactnumber
                (focusout)="inputChangedEvent(contactnumber)"
              />
              <mat-error xFormError="phoneNumber"></mat-error>
            </mat-form-field>
          </x-form-row>

          <x-form-row class="mb-4" heading="Address Search">
            <div class="addressing">
              <mat-form-field class="address-search">
                <mat-label>
                  <fa-icon icon="map-pin" xIconSize="small"></fa-icon>
                  {{ addressLabel }}
                </mat-label>
                <x-address-autocomplete
                  [formControl]="addressSearchControl"
                  [countryCode]="countryControl.value"
                  (searchQuery)="searchQuery($event)"
                >
                  <x-input-loader *xAddressLoader></x-input-loader>
                </x-address-autocomplete>
              </mat-form-field>

              <mat-form-field class="country-search">
                <mat-label>
                  <fa-icon icon="search" xIconSize="small"></fa-icon>
                  Search for your {{ 'country' | addressFormLabel: countryControl.value }}...
                </mat-label>
                <x-country-autocomplete [formControl]="countryControl" [required]="true">
                  <x-input-loader xSearchLoader></x-input-loader>
                </x-country-autocomplete>
              </mat-form-field>
            </div>
          </x-form-row>

          <x-form-row class="mb-4" heading="Address Detail">
            <div class="col-lg-12 mb-2">
              <mat-form-field>
                <mat-label>{{ 'street' | addressFormLabel: countryControl.value }}</mat-label>
                <input
                  matInput
                  [placeholder]="'street' | addressFormLabel: countryControl.value : '...'"
                  formControlName="street"
                  #street
                  (focusout)="inputChangedEvent(street)"
                />
                <mat-error xFormError="street"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>{{ 'postalCode' | addressFormLabel: countryControl.value }}</mat-label>
                <input
                  matInput
                  [placeholder]="'postalCode' | addressFormLabel: countryControl.value : '...'"
                  formControlName="postalCode"
                  #postalCode
                  (focusout)="inputChangedEvent(postalCode)"
                />
                <mat-error xFormError="postalCode"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>{{ 'suburb' | addressFormLabel: countryControl.value }}</mat-label>
                <input
                  matInput
                  [placeholder]="'suburb' | addressFormLabel: countryControl.value : '...'"
                  formControlName="suburb"
                  #suburb
                  (focusout)="inputChangedEvent(suburb)"
                />
                <mat-error xFormError="suburb"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>{{ 'city' | addressFormLabel: countryControl.value }}</mat-label>
                <input
                  matInput
                  [placeholder]="'city' | addressFormLabel: countryControl.value : '...'"
                  formControlName="city"
                  #city
                  (focusout)="inputChangedEvent(city)"
                />
                <mat-error xFormError="city"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>
                  <fa-icon icon="search" xIconSize="small"></fa-icon>
                  {{ 'province' | addressFormLabel: countryControl.value }}
                </mat-label>
                <x-province-autocomplete
                  [formControl]="provinceControl"
                  [countryCode]="countryControl.value"
                  [required]="provinceRequired"
                  [placeholder]="'province' | addressFormLabel: countryControl.value : '...'"
                >
                  <x-input-loader xSearchLoader></x-input-loader>
                </x-province-autocomplete>
                <mat-error xFormError="province"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>
                  {{ 'complex' | addressFormLabel: countryControl.value }}
                </mat-label>
                <input
                  matInput
                  [placeholder]="'complex' | addressFormLabel: countryControl.value : '...'"
                  formControlName="complex"
                  #complex
                  (focusout)="inputChangedEvent(complex)"
                />
                <mat-error xFormError="complex"></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>
                  {{ 'businessName' | addressFormLabel: countryControl.value }}
                </mat-label>
                <input
                  matInput
                  [placeholder]="'businessName' | addressFormLabel: countryControl.value : '...'"
                  formControlName="businessName"
                  #businessName
                  (focusout)="inputChangedEvent(businessName)"
                />
                <mat-error xFormError="businessName"></mat-error>
              </mat-form-field>
            </div>
          </x-form-row>

          <x-form-row class="mb-4" heading="Instructions">
            <mat-form-field>
              <mat-label>Address instructions</mat-label>
              <textarea
                matInput
                placeholder="Instructions..."
                formControlName="instructions"
                [maxLength]="instructionsMaxLength"
                rows="4"
                #instructions
                (focusout)="inputChangedEvent(instructions)"
              ></textarea>
              <mat-hint>
                {{ instructionsMaxLength - instructions.value.length }} characters remaining
              </mat-hint>
              <mat-error xFormError="instructions"></mat-error>
            </mat-form-field>
          </x-form-row>

          <x-form-row heading="Address Nickname">
            <div class="col-lg-6 mb-2">
              <mat-form-field>
                <mat-label>Give your address a name</mat-label>
                <input
                  matInput
                  placeholder="E.g., 'Work' or 'Home'"
                  formControlName="alias"
                  #alias
                  (focusout)="inputChangedEvent(alias)"
                />
                <mat-error xFormError="alias"></mat-error>
              </mat-form-field>
            </div>
          </x-form-row>
        </form>
      </x-form-panel>
    </mat-step>
    <mat-step
      [stepControl]="addressFormGroup"
      [editable]="true"
      state="map-pin"
      label="Pin location"
      class="address-map"
    >
      <div class="map-header p-2 p-lg-3">
        <h3 class="mb-2">Please make sure your address is pinned correctly.</h3>
        <p>
          Moving the pin won't update your street address, but we will use the coordinates of the
          pin to deliver your order.
        </p>
      </div>
      <x-address-map
        mapHeight="100%"
        [addressMarker]="addressFormGroup.value.coordinates"
        [defaultCoordinates]="data.defaultCoordinates"
        (coordinatesUpdate)="updateCoordinates($event)"
        [defaultZoom]="15"
      >
        <x-loader xLoader></x-loader>
      </x-address-map>
    </mat-step>

    <ng-template matStepperIcon="address">
      <fa-icon icon="clipboard-list" xIconColor="grey" xIconSize="small"></fa-icon>
    </ng-template>
    <ng-template matStepperIcon="map-pin">
      <fa-icon icon="map-pin" xIconColor="grey" xIconSize="small"></fa-icon>
    </ng-template>
    <ng-template matStepperIcon="edit">
      <fa-icon icon="pen-to-square" xIconColor="grey" xIconSize="small"></fa-icon>
    </ng-template>
    <ng-template matStepperIcon="done">
      <fa-icon icon="check" xIconColor="grey" xIconSize="small"></fa-icon>
    </ng-template>
  </mat-stepper>

  <button
    mat-flat-button
    color="primary"
    xSheetAction
    *ngIf="activeStep === 0"
    (click)="nextStep(operation)"
    [xButtonLoading]="operation.status === 'loading'"
  >
    Next
  </button>
  <button
    mat-stroked-button
    color="primary"
    xSheetAction
    (click)="previousStep(stepper)"
    *ngIf="activeStep === 1"
  >
    Previous
  </button>
  <button
    mat-flat-button
    color="primary"
    xSheetAction
    (click)="submit()"
    [disabled]="this.addressFormGroup.invalid"
    *ngIf="activeStep === 1"
  >
    {{ data.sheetTitle }}
  </button>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</x-bottom-sheet-layout>
